import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap5';
import { Link, Outlet, useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import PermissionsGate from 'components/Users/PermissionsGate';
import Table from 'components/new_ui/Table';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext as useTeamContext } from 'components/Managers/Teams/Context';
import { useContext as useTemplateContext } from 'components/Managers/Templates/Context';
import { useContext as useUsersContext } from 'components/Users/Context';
import useFinchStatus from 'components/Common/Members/Hooks/useFinchStatus';
import NoData from './NoData';
import columns from './columns';
import Invite from '../Invite/Index';
import EditMember from '../Edit/Index';
import { useContext } from '../../Context';

export default function Index() {
  const { dispatch, actions, state } = useContext();
  const { dispatch: dispatchTeam, actions: actionsTeam, state: stateTeam } = useTeamContext();
  const { dispatch: dispatchTemplate, actions: actionsTemplate, state: stateTemplate } = useTemplateContext();
  const { state: stateUser } = useUsersContext();
  const { loading: loadingFinchStatus, status: finchStatus } = useFinchStatus();

  const [invitedList, setInvitedList] = useState([]);
  const [editMember, setEditMember] = useState(null);

  const navigate = useNavigate();

  const selectMembersToInvite = (ids) => {
    const membersForInvite = (state.members || []).filter((item) => ids.includes(item.id)
      && item.attributes.possible_invite);
    if (membersForInvite.length === 0) {
      Alert({
        title: 'Invite',
        text: 'There are no members to invite at this time.',
        confirmButtonText: 'Close',
      });
    } else {
      setInvitedList(membersForInvite);
    }
  };

  const closeEditMember = () => {
    setEditMember(null);
  };

  const clearInvitedList = () => {
    setInvitedList([]);
  };

  let rowActions = [
    {
      type: 'EXPAND',
    },
    {
      title: 'Edit',
      type: 'CUSTOM',
      iconClass: 'edit-icon',
      onClick: (row) => { setEditMember(row); },
    },
  ];

  if (stateUser.user && stateUser.user.attributes.permissions['Send Invitation'] === 'edit') {
    rowActions = [...rowActions,
      {
        title: 'Invite',
        type: 'CUSTOM',
        iconClass: 'invite-icon',
        showCondition: (row) => row.attributes.possible_invite,
        onClick: (row) => { selectMembersToInvite([row.id]); },
      },
    ];
  }

  rowActions = [...rowActions,
    {
      title: 'Assessments',
      type: 'CUSTOM',
      iconClass: 'attachment-icon',
      onClick: (row) => { navigate(routes.managers.members.assessments(row.id)); },
    },
  ];

  if (stateUser.user && stateUser.user.attributes.permissions['Remove Members'] === 'edit') {
    rowActions = [...rowActions,
      {
        type: 'DIVIDER',
      },
      {
        title: 'Delete',
        type: 'CUSTOM',
        iconClass: 'trash-icon',
        onClick: (row, { clearSelected }) => {
          confirmAlert({
            title: 'Delete',
            text: 'Are you sure you want to delete?',
            confirmButtonText: 'Delete',
          }, () => {
            actions.delete(dispatch, row);
            clearSelected();
          });
        },
      },
    ];
  }

  let groupActions = [];

  if (stateUser.user && stateUser.user.attributes.permissions['Send Invitation'] === 'edit') {
    groupActions = [...groupActions, {
      title: 'Invite',
      iconClass: 'invite-icon',
      onClick: (selectedRows) => {
        selectMembersToInvite(selectedRows);
      },
    }];
  }

  if (stateUser.user && stateUser.user.attributes.permissions['Remove Members'] === 'edit') {
    groupActions = [...groupActions, {
      title: 'Delete',
      iconClass: 'trash-icon',
      onClick: (selectedRows, clearSelected) => {
        confirmAlert({
          title: 'Delete',
          text: 'Are you sure you want to delete?',
          confirmButtonText: 'Delete',
        }, () => {
          actions.deleteMulti(dispatch, selectedRows);
          clearSelected();
        });
      },
    }];
  }

  const teams = (stateTeam.teams || []).map((item) => item.attributes.title);
  const templates = (stateTemplate.templates || []).map((item) => item.attributes.title);

  useEffect(() => {
    actions.load(dispatch);
    actionsTeam.load(dispatchTeam);
    actionsTemplate.load(dispatchTemplate, stateTemplate.enterpriseId);
  }, []);

  return (
    <div className="content">
      <section>
        <Row>
          <Col>
            <h1>Members</h1>
          </Col>

          <PermissionsGate scopes={{ 'Add Members manually': ['edit'] }}>
            <Col xs="auto">
              {!loadingFinchStatus && finchStatus.status === 'connected' && (
                <Link
                  to={routes.managers.members.hrSystem.import}
                  className="btn btn-outline-primary btn-reverse my-2 my-md-0 me-3"
                >
                  Synch Members
                </Link>
              )}

              <Link
                to={routes.managers.members.add}
                className="btn btn-primary my-2 my-md-0"
              >
                Add New Members
              </Link>
            </Col>
          </PermissionsGate>
        </Row>
      </section>

      <section className="pt-2">
        <Table
          title=" "
          columns={columns(teams, templates)}
          data={state.members || []}
          loading={state.members == null}
          rowActions={rowActions}
          groupActions={groupActions}
          noData={<NoData />}
        />
      </section>

      <Invite members={invitedList} cancelCallback={clearInvitedList} sentCallback={clearInvitedList} />

      {editMember && (
        <EditMember
          member={editMember}
          closeEditMember={closeEditMember}
        />
      )}
      <Outlet />
    </div>
  );
}
